import { render } from "./VitrineFullscreenCarousel.vue?vue&type=template&id=ddd7c9be&scoped=true"
import script from "./VitrineFullscreenCarousel.vue?vue&type=script&lang=js"
export * from "./VitrineFullscreenCarousel.vue?vue&type=script&lang=js"

import "./VitrineFullscreenCarousel.vue?vue&type=style&index=0&id=ddd7c9be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd7c9be"]])

export default __exports__